import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { MenuItem } from '../MenuUtils';
import { MenuLink } from '../components/MenuLink';
//import { Link } from 'gatsby';
import rightChevron from '../../../../assets/icons/chevron-right.svg';

interface Props {
  rootMenuItems: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  closeMenu: () => void;
  isMinimalistHeader: boolean;
}

const MenuMobileFirstLevel: FunctionComponent<Props> = ({ rootMenuItems, setMenuSelectedPath, closeMenu, isMinimalistHeader }) => {
  const productIndex = rootMenuItems.findIndex(({ key, href }) => key === 'rootProducts' && !href?.includes('draft'));

  let productEntry = rootMenuItems[productIndex];

  const newItems = [...rootMenuItems];
  newItems.splice(productIndex, 1);

  const minimalistMenuItems = newItems.filter((item: MenuItem) => item.label == 'Produits');
  const menuList = isMinimalistHeader ? minimalistMenuItems : newItems;

  return (
    <StyledCategoryContainer>
      <StyledCategory>
        <StyledMenuLink item={productEntry} closeMenu={closeMenu} onClick={() => setMenuSelectedPath([productEntry])}>
          {productEntry.label}

          <img src={rightChevron} className="navigate" alt="navigate" />
        </StyledMenuLink>
      </StyledCategory>
      {menuList.map((item: MenuItem, index: React.Key | null | undefined) => (
        <StyledCategory key={index}>
          <StyledLink href={item.href} closeMenu={closeMenu} onClick={closeMenu}>
            {item.label}
          </StyledLink>
        </StyledCategory>
      ))}
    </StyledCategoryContainer>
  );
};

const StyledCategoryContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  align-self: flex-start;
`;

const StyledCategory = styled.li`
  font-size: 14px;
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledMenuLink = styled(MenuLink)`
  position: relative;
  display: block;
  font-family: 'Styrene Medium';
  color: #323232;
  text-decoration: none;
  transition: color 0.2s ease-in-out;
  width: 100%;
  .navigate {
    position: absolute;
    right: 0px;
  }
  &:hover {
    color: #ff0b75;
  }
`;
const StyledLink = styled('a')`
  display: block;
  font-family: 'Styrene Medium';
  color: #323232;
  text-decoration: none;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #ff0b75;
  }
`;

export default MenuMobileFirstLevel;
